import React, { Component } from 'react';
import placeholder from '../../assets/images/placeholder.png';
import back from '../../assets/icons/back.svg';
import forward from '../../assets/icons/next.svg';
import CarouselImage from './CarouselImage';

import { createImageUrl } from '../../helpers/commonHelpers';
import Button from './Button';
import x from '../../assets/icons/x.svg';
import { isMobile } from 'react-device-detect';

class Carousel extends Component {

    state = {
        activeImage: null,
        activeImageIndex: 0,
        currentIndex: 0,
        imageModalOpen: false,
        initialClientX: 0,
        finalClientX: 0,
        initialClientY: 0,
        finalClientY: 0,
    }

    componentDidMount() {
        const { images } = this.props;

        if(images && images.length) {
            this.setState({
                ...this.state,
                activeImage: images[0]
            })
        }
    }

    componentDidUpdate(prevProps) {
        const { images } = this.props;

        if(images && images.length && prevProps.images !== images) {
            this.setState({
                ...this.state,
                activeImage: images[0]
            })
        }
    }
    render() {
        const { activeImage, currentIndex, activeImageIndex, imageModalOpen } = this.state;
        const { images, imageCount } = this.props;
        return (
            <div className={`carousel ${imageModalOpen ? 'carousel__modal-open' : ''}`}>
                <div onClick={this.openImageModal} className="carousel__active" style={{backgroundImage: `url("${activeImage ? createImageUrl(activeImage) : placeholder }")`}} >
                    <div className="carousel__images">

                        {activeImageIndex ? <img onClick={this.decrementImage} className="carousel__arrow" src={back} alt="arrow-left" /> : <div className="carousel__placeholder" />}

                        {images && images.length ?
                            <div  className="carousel__images__container">
                                {images.map((image, index) => {
                                    return <CarouselImage key={index} setCarouselImage={this.setCarouselImage} image={image} index={index} currentIndex={currentIndex} activeImageIndex={activeImageIndex} />
                                })}
                            </div>
                        : null}

                        {activeImageIndex + 1 !== imageCount && imageCount ? <img onClick={this.incrementImage} className="carousel__arrow" src={forward} alt="arrow-right" /> : <div className="carousel__placeholder" />}

                    </div>
                </div>
                {imageModalOpen ? <img onClick={this.openImageModal} src={x} alt="close" className="carousel__modal__close" /> : null}
                {imageModalOpen ?
                    <div onTouchStart={isMobile ? this.handleTouchStart : null} onTouchMove={isMobile ? this.handleTouchMove : null} onTouchEnd={isMobile ? this.handleTouchEnd : null} className="carousel__modal">
                        {!isMobile ? <input readOnly onKeyDown={this.handleKeyPress} autoFocus={true} className="carousel__hidden" /> : null}

                        <img className="carousel__modal__image" src={createImageUrl(activeImage)} alt="active" />
                        <h1 className="carousel__modal__title">
                            Slika {currentIndex + 1}/{imageCount}
                        </h1>
                        {!isMobile ? <Button onClick={this.decrementImage} classes="carousel__modal__button carousel__modal__button--left" color="yellow-dark" text="&larr;" /> : null}
                        {!isMobile ? <Button onClick={this.incrementImage} classes="carousel__modal__button carousel__modal__button--right" color="yellow-dark" text="&rarr;" /> : null}
                    </div>
                : null}
            </div>
        );
    }

    openImageModal = (event) => {
        event.stopPropagation();
        if(this.props.imageCount === 0) return;
        this.setState({
            imageModalOpen: !this.state.imageModalOpen
        })
    }
    setCarouselImage = (event, img, index) => {
        event.stopPropagation();
        const { imageCount } = this.props;

        this.setState({
            activeImage: img,
            currentIndex: index >= imageCount - 1 ? imageCount - 1 : index,
            activeImageIndex: index
        })
    }

    incrementImage = (event) => {
        event.stopPropagation();
        const { currentIndex, activeImageIndex } = this.state;
        const { imageCount, images } = this.props;

        const noImages = !images || !images.length;
        const lastImage = images.length - 1 === currentIndex;
        if (noImages || lastImage) return;

        this.setState({
            currentIndex: currentIndex + 1 === imageCount && imageCount > 2 ? currentIndex : currentIndex + 1,
            activeImageIndex: activeImageIndex + 1 ===  imageCount ? activeImageIndex : activeImageIndex + 1,
            activeImage: activeImageIndex + 1 === imageCount ? images[activeImageIndex] : images[activeImageIndex + 1]
        })
    }

    decrementImage = (event) => {
        event.stopPropagation();
        const { currentIndex, activeImageIndex } = this.state;
        const { images } = this.props;

        const noImages = !images || !images.length;
        const firstImage = currentIndex === 0;

        if (noImages || firstImage) return;

        this.setState({
            currentIndex: currentIndex === 0 ? currentIndex : currentIndex - 1,
            activeImageIndex: activeImageIndex === 0 ? activeImageIndex : activeImageIndex - 1,
            activeImage:  activeImageIndex === 0 ? images[activeImageIndex] : images[activeImageIndex - 1]
        })
    }

    handleTouchStart = (event) => {

        this.setState({
            initialClientX: event?.nativeEvent?.touches[0]?.clientX,
            initialClientY: event?.nativeEvent?.touches[0]?.clientY
        });
    }

    handleTouchMove = (event) =>  {
        this.setState({
            finalClientX: event?.nativeEvent?.touches[0]?.clientX,
            finalClientY: event?.nativeEvent?.touches[0]?.clientY
        });
    }

    handleTouchEnd = (event) =>  {
        if (this.state.finalClientX < this.state.initialClientX && (Math.abs(this.state.finalClientY - this.state.initialClientY) < 50)) {
            this.incrementImage(event);
        }
        if (this.state.finalClientX > this.state.initialClientX && (Math.abs(this.state.finalClientY - this.state.initialClientY) < 50)) {
            this.decrementImage(event);
        }
        this.setState({
            initialClientX: 0,
            finalClientX: 0,
            initialClientY:0,
            finalClientY:0
        });
    }
    handleKeyPress = (event) => {

        if(event.key === 'ArrowRight'){
            this.incrementImage(event);
        }
        else if(event.key === 'ArrowLeft'){
            this.decrementImage(event);
        }
        else if(event.key === 'Escape'){
            this.openImageModal(event);
        }
    }
}

export default Carousel;